import { render, staticRenderFns } from "./fmFile.vue?vue&type=template&id=237af84c"
import script from "./fmFile.vue?vue&type=script&lang=js"
export * from "./fmFile.vue?vue&type=script&lang=js"
import style0 from "./fmFile.vue?vue&type=style&index=0&id=237af84c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports